import { render } from "./monitoringProgressV2.vue?vue&type=template&id=5234948d&scoped=true"
import script from "./monitoringProgressV2.vue?vue&type=script&lang=js"
export * from "./monitoringProgressV2.vue?vue&type=script&lang=js"

import "./monitoringProgressV2.vue?vue&type=style&index=0&id=5234948d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5234948d"

export default script